import React from 'react';

import { Interpolation, css, styled } from 'styled-components';

export const FlexContainer = styled('div')<{
  $column?: boolean;
  $center?: boolean;
  $responsive?: boolean;
  $responsiveWrap?: boolean;
  $padding?: number;
  $gap?: number;
  $wrap?: boolean;
  $w100?: boolean;
  $h100?: boolean;
  $styles?: Interpolation<object>;
}>(
  ({
    $column,
    $padding = 0,
    $center,
    $responsive,
    $responsiveWrap,
    $gap = 0,
    $wrap,
    $w100,
    $h100,
    $styles,
    theme,
  }) => css`
    display: flex;
    flex-direction: ${$column ? 'column' : 'row'};
    padding: ${`${$padding}rem`};
    flex-wrap: ${$wrap ? 'wrap' : 'nowrap'};
    align-items: ${$center ? 'center' : 'flex-start'};
    justify-content: ${$center ? 'center' : 'flex-start'};
    width: ${$w100 ? '100%' : 'auto'};
    height: ${$h100 ? '100%' : 'auto'};
    gap: ${`${$gap}rem`};
    ${$styles}

    ${$responsive &&
    css`
      width: 50%;

      @media (max-width: ${theme.breakpoints.lg}) {
        width: 100%;
      }
    `}

    ${$responsiveWrap &&
    css`
      @media (max-width: ${theme.breakpoints.lg}) {
        flex-wrap: wrap;
      }
    `}
  `
);

type Props = {
  children: React.ReactNode;
  center?: boolean;
  responsive?: boolean;
  responsiveWrap?: boolean;
  column?: boolean;
  w100?: boolean;
  h100?: boolean;
  wrap?: boolean;
  padding?: number;
  gap?: number;
  styles?: Interpolation<object>;
};

const Flex: React.FC<Props> = ({
  children,
  w100,
  h100,
  gap,
  wrap,
  center,
  responsive,
  responsiveWrap,
  column,
  padding,
  styles,
}) => {
  return (
    <FlexContainer
      $w100={w100}
      $h100={h100}
      $gap={gap}
      $wrap={wrap}
      $column={column}
      $center={center}
      $responsive={responsive}
      $responsiveWrap={responsiveWrap}
      $padding={padding}
      $styles={styles}
    >
      {children}
    </FlexContainer>
  );
};

export default Flex;
